import { useEffect, useState } from "react";

function stripUnsafeSvg(raw) {
  return raw
    .replace(/<script[\s\S]*?<\/script>/gi, "")
    .replace(/\son\w+\s*=\s*(['"])[^'"]*\1/gi, "")
    .replace(/\son\w+\s*=\s*[^\s>]+/gi, "")
    // Remove fixed width/height from the <svg> root so CSS can control the size
    .replace(/(<svg[^>]*?)\s+width\s*=\s*["'][^"']*["']/i, "$1")
    .replace(/(<svg[^>]*?)\s+height\s*=\s*["'][^"']*["']/i, "$1");
}

export default function Avatar({ src, alt = "avatar", className = "" }) {
  const [svg, setSvg] = useState("");
  const [isSvg, setIsSvg] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!src) return;

    const checkSvg = src.toLowerCase().endsWith(".svg");
    setIsSvg(checkSvg);

    if (!checkSvg) {
      setLoading(false);
      return;
    }

    const safeUrl = encodeURI(src);
    let isMounted = true;

    const fetchWithRetry = async (retries = 3, delay = 500) => {
      try {
        const res = await fetch(safeUrl);
        if (!res.ok) throw new Error("Fetch failed");
        const data = await res.text();
        if (isMounted) setSvg(stripUnsafeSvg(data));
      } catch (err) {
        if (retries > 0) {
          setTimeout(() => fetchWithRetry(retries - 1, delay * 2), delay);
        } else {
          console.error("SVG load error:", err);
          if (isMounted) setSvg("");
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    setLoading(true);
    fetchWithRetry();

    return () => { isMounted = false; };
  }, [src]);

  if (loading) {
    return <div className={className} style={{ background: "#eee" }} />;
  }

  if (isSvg && svg) {
    return <div className={className} dangerouslySetInnerHTML={{ __html: svg }} />;
  }

  return <img src={src} alt={alt} className={className} />;
}